const LoginScreen = {
    // Colección diversa de avatares (45 emojis)
    avatarSeeds: [
        // 5 Robots (diferentes colores y formas)
        '🤖', '🦾', '👾', '🛸', '⚙️', '🦿', '🚀', '🛰️', '🔭', '🎮',

        // 4 Monstruos
        '👹', '👺', '👻', '👽',

        // 4 Animales Fantásticos
        '🐉', '🦄', '🐲', '🦖',

        // 10 Personajes/Profesiones
        '👨‍🚀', '👮', '👨‍🚒', '⚽', '✈️', '🏃', '🧙', '🧚', '🏴‍☠️', '🤿',

        // 6 Niños (diversidad étnica)
        '👦🏻', '👦🏽', '👦🏿', '👦', '👦🏾', '👦🏼',

        // 6 Niñas (diversidad étnica)
        '👧🏻', '👧🏽', '👧🏿', '👧', '👧🏾', '👧🏼',

        // 10 Animales
        '🐱', '🐶', '🦒', '🐴', '🦁', '🐘', '🐼', '🐨', '🐯', '🐻'
    ],

    init() {
        Logger.info('🔒 LoginScreen: Inicializando...');

        // ED-03: Aplicar Branding de Editorial
        if (window.PUBLISHER_CONFIG && window.PUBLISHER_CONFIG.branding) {
            const { appName } = window.PUBLISHER_CONFIG.branding;
            if (appName) {
                document.title = appName;
                document.querySelectorAll('.main-title, .splash-title, .login-title').forEach(el => {
                    el.textContent = appName;
                });
            }
        }
        
        // ED-01: Bypass para DEMO Editorial
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('mode') === 'demo') {
            Logger.info('🚀 Modo Demo Editorial activado. Saltando login...');
            setTimeout(() => {
                if (window.UserManager) window.UserManager.loginGuest();
                document.getElementById('loginScreen').classList.add('hidden');
                document.getElementById('loginScreen').classList.remove('active');
                
                // Forzar configuración rápida y saltar a aventura
                if (window.store && window.store.dispatch) {
                    window.store.dispatch('generateProblems');
                }
                this.initGlobalServices();
                this.proceedToWelcome();
                
                // Auto-click start
                setTimeout(() => {
                    const btn = document.querySelector('.btn-start-investigation');
                    if (btn) btn.click();
                }, 500);
            }, 100);
            return;
        }

        this.renderProfiles();
        this.setupEventListeners();
        Logger.info('🔒 LoginScreen: Eventos configurados correctamente');
    },

    /**
     * Devuelve el emoji del avatar directamente
     */
    getAvatarURL(seed) {
        // Los avatares ahora son emojis, así que devolvemos el seed directamente
        return seed;
    },

    renderProfiles() {
        const grid = document.getElementById('profilesGrid');
        if (!grid) return;

        grid.innerHTML = '';
        const users = window.UserManager.users;

        if (users.length === 0) {
            grid.innerHTML = '<p style="text-align:center; width:100%; opacity:0.7; color:white;">No hay investigadores registrados aún.</p>';
            return;
        }

        users.forEach(user => {
            const card = document.createElement('div');
            card.className = 'profile-card';
            card.onclick = () => this.startLoginChallenge(user.id);

            card.innerHTML = `
                <button class="profile-delete-btn" onclick="window.LoginScreen.deleteProfile(event, '${user.id}')">✕</button>
                <div class="profile-avatar-container">
                    <!-- PRIVACY: Show generic icon instead of secret avatar -->
                    <div style="width:100%; height:100%; display:flex; align-items:center; justify-content:center; font-size:3rem;">
                        🕵️
                    </div>
                </div>
                <span class="profile-name">${user.name}</span>
            `;

            grid.appendChild(card);
        });
    },

    setupEventListeners() {
        // Helper para añadir listener seguro
        const addListener = (id, event, handler) => {
            const el = document.getElementById(id);
            if (el) el.addEventListener(event, handler);
            /* muted warning */
        };

        // Botón Nuevo Perfil
        addListener('newProfileBtn', 'click', () => {
            const modal = document.getElementById('newProfileModal');
            if (modal) {
                modal.classList.remove('hidden');
                this.renderAvatarOptions();
                this.selectAvatar(this.avatarSeeds[0]);
                const nameInput = document.getElementById('newProfileName');
                if (nameInput) {
                    nameInput.value = '';
                    nameInput.focus();
                }
            }
        });

        // Invitado
        addListener('guestBtn', 'click', () => {
            if (window.UserManager) {
                window.UserManager.loginGuest();
                
                // Hide login screen
                const loginScreen = document.getElementById('loginScreen');
                if (loginScreen) {
                    loginScreen.classList.add('hidden');
                    loginScreen.classList.remove('active');
                }
                
                this.initGlobalServices();
                if (window.SessionManager) {
                    window.SessionManager.showWelcomeScreen();
                } else {
                    this.proceedToWelcome();
                }
            }
        });

        // ED-04: Eventos de Licencia de Centro
        addListener('centerLoginBtn', 'click', () => {
            const container = document.getElementById('licenseContainer');
            if (container) {
                container.style.display = container.style.display === 'none' ? 'block' : 'none';
            }
        });

        addListener('activateLicenseBtn', 'click', () => {
            const input = document.getElementById('licenseInput');
            if (input && input.value.trim().toUpperCase() === 'DEMO-ED-2026') {
                alert('✅ ¡Licencia de Centro activada correctamente! (Modo Demo Editorial)');
                document.getElementById('guestBtn').click(); // Redirige como invitado para la demo
            } else {
                alert('❌ Código de licencia no válido.');
            }
        });

        // Modales y Controles
        addListener('cancelProfileBtn', 'click', () => {
            if (window.stopAudio) window.stopAudio();
            document.getElementById('newProfileModal').classList.add('hidden');
        });

        addListener('createProfileBtn', 'click', () => {
            this.handleCreateProfile();
        });

        addListener('cancelChallengeBtn', 'click', () => {
            if (window.stopAudio) window.stopAudio();
            document.getElementById('loginChallengeModal').classList.add('hidden');
        });

        // Delegación para selección de avatar (class selector)
        const avatarOptions = document.querySelector('.avatar-options');
        if (avatarOptions) {
            avatarOptions.addEventListener('click', (e) => {
                const btn = e.target.closest('.avatar-option');
                if (btn) {
                    this.selectAvatar(btn.dataset.avatar);
                }
            });
        }

        addListener('newProfileName', 'input', (e) => {
            const btn = document.getElementById('createProfileBtn');
            if (btn) btn.disabled = e.target.value.trim().length < 2;
        });

        // Admin (Dashboard)
        addListener('profesBtn', 'click', () => {
            if (window.ParentsDashboard) {
                window.ParentsDashboard.show('teacher');
            }
        });

        addListener('padresBtn', 'click', () => {
            if (window.ParentsDashboard) {
                window.ParentsDashboard.show('parent');
            }
        });

        // Centro Educativo
        addListener('centerLoginBtn', 'click', () => {
            const modal = document.getElementById('centerAuthModal');
            if (modal) modal.classList.remove('hidden');
        });

        addListener('submitCenterAuth', 'click', () => {
            this.handleCenterAuth();
        });
    },

    closeCenterAuth() {
        const modal = document.getElementById('centerAuthModal');
        if (modal) modal.classList.add('hidden');
        const error = document.getElementById('centerAuthError');
        if (error) error.classList.add('hidden');
    },

    handleCenterAuth() {
        const user = document.getElementById('centerUser').value.trim();
        const pass = document.getElementById('centerPass').value.trim();
        const errorEl = document.getElementById('centerAuthError');

        // [CAMBIO] Credenciales específicas usando hash local simulado
        // SHA-256 de "123456" es "8d969eef6ecad3c29a3a629280e686cf0c3f5d5a86aff3ca12020c923adc6c92"
        async function checkHash(input) {
            const msgUint8 = new TextEncoder().encode(input);
            const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
            return hashHex === '8d969eef6ecad3c29a3a629280e686cf0c3f5d5a86aff3ca12020c923adc6c92';
        }

        checkHash(pass).then(isValid => {
            if (user === 'CENTRO' && isValid) {
                console.log('🏫 Centro Educativo autenticado con éxito');
                this.closeCenterAuth();

                // Abrir el panel de gestión para añadir profesores
                this.showCenterManagement();

                // Efecto visual de éxito en el botón de la pantalla principal
                const btn = document.getElementById('centerLoginBtn');
                if (btn) {
                    btn.innerHTML = '<span style="margin-right: 8px;">✅</span> CENTRO CONECTADO';
                    btn.style.background = 'linear-gradient(135deg, #10b981, #059669) !important';
                    btn.style.boxShadow = '0 4px 0 #059669, 0 8px 15px rgba(0,0,0,0.2) !important';
                }

                if (window.UserManager) {
                    window.UserManager.centerLoggedIn = true;
                    window.UserManager.centerName = user;
                }
            } else {
                if (errorEl) {
                    errorEl.textContent = 'Usuario o contraseña de centro incorrectos';
                    errorEl.classList.remove('hidden');
                }
            }
        });
    },

    showCenterManagement() {
        const modal = document.getElementById('centerManagementModal');
        if (modal) {
            modal.classList.remove('hidden');
            this.renderTeachers();
        }
    },

    closeCenterManagement() {
        const modal = document.getElementById('centerManagementModal');
        if (modal) modal.classList.add('hidden');
    },

    // --- LÓGICA DE GESTIÓN DE PROFESORES Y CURSOS ---

    getTeachersData() {
        try {
            const stored = localStorage.getItem('detectives_center_teachers');
            return stored ? JSON.parse(stored) : [];
        } catch (_e) {
            return [];
        }
    },

    saveTeachersData(teachers) {
        localStorage.setItem('detectives_center_teachers', JSON.stringify(teachers));
    },

    addTeacher() {
        const nameInput = document.getElementById('newTeacherName');
        const name = nameInput.value.trim();

        if (!name) return;

        const teachers = this.getTeachersData();
        const newTeacher = {
            id: 'teacher_' + Date.now(),
            name: name,
            courses: [] // Array: ['1ºA', '1ºB']
        };

        teachers.push(newTeacher);
        this.saveTeachersData(teachers);

        nameInput.value = '';
        this.renderTeachers();
    },

    renderTeachers() {
        const container = document.getElementById('teachersListContainer');
        const template = document.getElementById('teacherItemTemplate');
        if (!container || !template) return;

        container.innerHTML = '';
        const teachers = this.getTeachersData();

        if (teachers.length === 0) {
            container.innerHTML = '<p style="text-align:center; opacity:0.6; padding: 2rem; color: #475569;">No hay profesores registrados aún.</p>';
            return;
        }

        teachers.forEach(teacher => {
            const clone = template.content.cloneNode(true);
            const card = clone.querySelector('.teacher-card');

            card.dataset.id = teacher.id;
            clone.querySelector('.teacher-name').textContent = teacher.name;

            // Renderizar cursos asignados
            const coursesList = clone.querySelector('.assigned-courses-list');
            const targetSelect = clone.querySelector('.target-course-select');

            teacher.courses.forEach(course => {
                // Badge
                const badge = document.createElement('span');
                badge.className = 'course-badge';
                badge.style.cssText = 'background: #e0f2fe; color: #0369a1; padding: 6px 14px; border-radius: 20px; font-weight: 700; font-size: 0.85rem; display: flex; align-items: center; gap: 8px; border: 1px solid #bae6fd;';
                badge.innerHTML = `<span>📚 ${course}</span> <span style="cursor:pointer; color:#ef4444; font-size: 1.1rem;" onclick="window.LoginScreen.removeCourse('${teacher.id}', '${course}')">✕</span>`;
                coursesList.appendChild(badge);

                // Option en el select de alumnos
                if (targetSelect) {
                    const opt = document.createElement('option');
                    opt.value = course;
                    opt.textContent = course;
                    targetSelect.appendChild(opt);
                }
            });

            // Seleccionar el último curso por defecto si existe
            if (targetSelect && teacher.courses.length > 0) {
                targetSelect.value = teacher.courses[teacher.courses.length - 1];
            }

            container.appendChild(clone);
        });
    },

    deleteTeacher(btn) {
        const card = btn.closest('.teacher-card');
        const id = card.dataset.id;

        if (confirm('¿Seguro que quieres eliminar a este profesor y todas sus asignaciones?')) {
            let teachers = this.getTeachersData();
            teachers = teachers.filter(t => t.id !== id);
            this.saveTeachersData(teachers);
            this.renderTeachers();
        }
    },

    assignCourse(btn) {
        const card = btn.closest('.teacher-card');
        const teacherId = card.dataset.id;
        const select = card.querySelector('.course-select');
        const course = select.value;

        const teachers = this.getTeachersData();
        const teacher = teachers.find(t => t.id === teacherId);

        if (teacher && !teacher.courses.includes(course)) {
            teacher.courses.push(course);
            this.saveTeachersData(teachers);
            this.renderTeachers();
        }
    },

    removeCourse(teacherId, course) {
        const teachers = this.getTeachersData();
        const teacher = teachers.find(t => t.id === teacherId);

        if (teacher) {
            teacher.courses = teacher.courses.filter(c => c !== course);
            this.saveTeachersData(teachers);
            this.renderTeachers();
        }
    },

    uploadStudents(btn) {
        const card = btn.closest('.teacher-card');
        const teacherId = card.dataset.id;
        const textarea = card.querySelector('.student-list-input');
        const countDisplay = card.querySelector('.students-count');
        const countVal = card.querySelector('.count-val');
        const courseVal = card.querySelector('.course-val');
        const targetSelect = card.querySelector('.target-course-select');

        const text = textarea.value.trim();
        if (!text) return;

        const names = text.split('\n').map(n => n.trim()).filter(n => n.length > 0);
        if (names.length === 0) return;

        const targetGroup = targetSelect.value || '1ºA';
        console.log(`👥 Registrando ${names.length} alumnos en el curso ${targetGroup}...`);

        let addedCount = 0;
        names.forEach(name => {
            // Seleccionar avatar aleatorio
            const randomAvatar = this.avatarSeeds[Math.floor(Math.random() * this.avatarSeeds.length)];

            // Crear usuario real en el sistema
            if (window.UserManager) {
                const newUser = window.UserManager.createUser(name, randomAvatar);
                if (newUser && targetGroup !== '1ºA') {
                    window.UserManager.updateUserGroup(newUser.id, targetGroup);
                }
                addedCount++;
            }
        });

        // Feedback visual
        textarea.value = '';
        if (countDisplay && countVal) {
            countVal.textContent = addedCount;
            if (courseVal) courseVal.textContent = targetGroup;
            countDisplay.style.display = 'block';

            // Ocultar tras unos segundos
            setTimeout(() => {
                countDisplay.style.opacity = '0';
                setTimeout(() => {
                    countDisplay.style.display = 'none';
                    countDisplay.style.opacity = '1';
                }, 1000);
            }, 5000);
        }

        // Refrescar perfiles de login
        this.renderProfiles();

        alert(`✅ ¡Éxito! Se han registrado ${addedCount} alumnos en el curso ${targetGroup} con sus nuevos avatares.`);
    },

    showTeacherCredentials(btn) {
        const card = btn.closest('.teacher-card');
        const teacherId = card.dataset.id;
        const teachers = this.getTeachersData();
        const teacher = teachers.find(t => t.id === teacherId);

        if (!teacher) return;

        const modal = document.getElementById('credentialsModal');
        const title = document.getElementById('credentialsTeacherName');
        const listDiv = document.getElementById('credentialsList');

        if (!modal || !title || !listDiv) return;

        // Reset
        title.textContent = `Profesor/a: ${teacher.name} (${teacher.courses.join(', ') || 'Sin curso'})`;
        listDiv.innerHTML = '';

        // Cursos del profesor
        const teacherGroups = teacher.courses;

        // Alumnos registrados en esos grupos
        const students = window.UserManager ? window.UserManager.users.filter(u => teacherGroups.includes(u.group)) : [];

        if (students.length === 0) {
            listDiv.innerHTML = '<p style="text-align:center; padding:1rem; opacity:0.6;">No hay alumnos registrados en tus cursos asignados.</p>';
        } else {
            const table = document.createElement('table');
            table.style.width = '100%';
            table.style.borderCollapse = 'collapse';

            students.forEach(s => {
                const tr = document.createElement('tr');
                tr.style.borderBottom = '1px solid #e2e8f0';
                tr.innerHTML = `
                    <td style="padding: 10px; font-weight: 700;">${s.name}</td>
                    <td style="padding: 10px; font-size: 1.5rem;">${s.avatar}</td>
                    <td style="padding: 10px; color: #64748b; font-size: 0.8rem;">${s.group}</td>
                `;
                table.appendChild(tr);
            });
            listDiv.appendChild(table);
        }

        // Guardar datos temporales para descarga
        this.currentCredentialsData = {
            teacher: teacher.name,
            students: students
        };

        modal.classList.remove('hidden');
    },

    downloadCredentials() {
        if (!this.currentCredentialsData || !this.currentCredentialsData.students.length) {
            alert('No hay alumnos para descargar.');
            return;
        }

        const data = this.currentCredentialsData;
        let content = `LISTADO DE CREDENCIALES - PROFESOR: ${data.teacher}\n`;
        content += `====================================================\n\n`;

        data.students.forEach(s => {
            content += `- ALUMNO/A: ${s.name.padEnd(20)} | AVATAR: ${s.avatar} | GRUPO: ${s.group}\n`;
        });

        content += `\nGenerado el: ${new Date().toLocaleString()}\n`;

        const blob = new Blob([content], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Credenciales_${data.teacher.replace(/\s+/g, '_')}.txt`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    },

    renderAvatarOptions() {
        const container = document.querySelector('.avatar-options');
        if (!container) return;

        container.innerHTML = this.avatarSeeds.map(seed => `
            <button class="avatar-option" data-avatar="${seed}" style="font-size: 2rem;">
                ${seed}
            </button>
        `).join('');
    },

    selectAvatar(seed) {
        document.querySelectorAll('.avatar-option').forEach(btn => {
            btn.classList.toggle('selected', btn.dataset.avatar === seed);
        });

        // Preview grande
        const preview = document.getElementById('newProfileAvatarPreview');
        if (preview) {
            preview.innerHTML = `<div style="font-size: 4rem; line-height: 1; display: flex; justify-content: center; align-items: center;">${seed}</div>`;
        }

        this.selectedAvatar = seed;
    },

    selectGroup(group) {
        this.selectedGroup = group;
        // Update UI
        document.querySelectorAll('.group-btn').forEach(btn => {
            btn.classList.toggle('selected', btn.textContent === group);
        });
    },

    handleCreateProfile() {
        const nameInput = document.getElementById('newProfileName');
        const name = nameInput.value.trim();
        const group = this.selectedGroup || '1A';

        if (name && this.selectedAvatar) {
            // Update to accept group
            const user = window.UserManager.createUser(name, this.selectedAvatar);
            if (user) {
                // Ensure group is set (in case createUser signature wasn't updated in memory yet, though we updated UserManager)
                window.UserManager.updateUserGroup(user.id, group);
            }

            document.getElementById('newProfileModal').classList.add('hidden');
            this.renderProfiles();
        }
    },

    /**
     * Mezcla un array usando el algoritmo Fisher-Yates para asegurar
     * aleatoriedad perfecta sin perder elementos.
     */
    shuffleArray(array) {
        const newArray = [...array];
        for (let i = newArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
        }
        return newArray;
    },

    /**
     * Inicia el desafío visual (Contraseña)
     */
    startLoginChallenge(userId) {
        const user = window.UserManager.users.find(u => u.id === userId);
        if (!user) return;

        this.pendingLoginUserId = userId;
        // PRIVACY: Removed name from title to prevent revealing identity to others
        document.getElementById('challengeUserTitle').textContent = `¿Cuál es tu dibujo secreto?`;

        const grid = document.getElementById('challengeGrid');
        grid.innerHTML = '';

        // Crear lista de opciones: correcto + 5 distractores aleatorios
        let options = [user.avatar];
        const others = this.avatarSeeds.filter(s => s !== user.avatar);

        // Mezclar otros (Fisher-Yates) y pillar 5
        const shuffledOthers = this.shuffleArray(others);
        const distractors = shuffledOthers.slice(0, 5);
        options = options.concat(distractors);

        // Mezclar todas las opciones (Fisher-Yates)
        options = this.shuffleArray(options);

        options.forEach(seed => {
            const btn = document.createElement('div');
            btn.className = 'challenge-item';
            btn.onclick = () => this.verifyChallenge(seed);
            btn.innerHTML = `<div style="font-size: 4rem;">${seed}</div>`;
            grid.appendChild(btn);
        });

        document.getElementById('loginChallengeModal').classList.remove('hidden');
    },

    verifyChallenge(selectedSeed) {
        const user = window.UserManager.users.find(u => u.id === this.pendingLoginUserId);

        if (user && selectedSeed === user.avatar) {
            // ¡Correcto!
            document.getElementById('loginChallengeModal').classList.add('hidden');
            if (window.UserManager.loginUser(user.id)) {
                this.initGlobalServices();
                if (window.SessionManager && window.SessionManager.showConfigScreen) {
                    window.SessionManager.showConfigScreen();
                } else if (typeof window.showConfigScreen === 'function') {
                    window.showConfigScreen();
                } else {
                    this.proceedToWelcome();
                }
            }
        } else {
            // Error - Efecto visual
            const content = document.querySelector('.challenge-modal');
            content.classList.add('shake');
            setTimeout(() => content.classList.remove('shake'), 500);

            // Re-mezclar para que no sea tan fácil acertar por azar puro tras un fallo
            setTimeout(() => this.startLoginChallenge(this.pendingLoginUserId), 600);
        }
    },

    initGlobalServices() {
        if (window.GamificationService) {
            window.GamificationService.init();
        }
        if (window.StickerStore) window.StickerStore.loadInventory();
        if (window.DetectiveMentor) {
            window.DetectiveMentor.init();
            window.DetectiveMentor.show();
        }
        if (window.AdventureMap) window.AdventureMap.init();
    },

    proceedToWelcome() {
        window.scrollTo(0, 0);
        showWelcomeScreen();

        if (window.UIManager) {
            window.UIManager.renderWelcomeScreen(false); // NO reproducir audio automáticamente tras login
            window.UIManager.updateUILanguage();
        }

        setTimeout(() => {
            this.initGlobalServices();
            // Audio is handled by window.UIManager.renderWelcomeScreen() - no need to call it here
        }, 300);
    },

    deleteProfile(event, userId) {
        event.stopPropagation();
        if (confirm('¿Seguro que quieres borrar este detective? Se perderá todo su progreso.')) {
            window.UserManager.deleteUser(userId);
            this.renderProfiles();
        }
    }
};

// Expose globally explicitly
window.LoginScreen = LoginScreen;

window.showLoginScreen = function (force = false) {
    // Si no es una llamada forzada (clic del usuario) y estamos en la Splash Screen, ignoramos
    const splash = document.getElementById('splashScreen');
    if (!force && splash && splash.classList.contains('active')) {
        console.log('🛡️ Bloqueada transición automática a Login desde Splash Screen');
        return;
    }

    const login = document.getElementById('loginScreen');
    const welcome = document.getElementById('welcomeScreen');

    if (login) {
        login.classList.remove('hidden');
        login.classList.add('active');
    }

    if (welcome) {
        welcome.classList.add('hidden');
        welcome.classList.remove('active');
    }

    if (window.stopAudio) window.stopAudio();

    document.querySelectorAll('.screen').forEach(s => {
        if (s.id !== 'loginScreen') {
            s.classList.add('hidden');
            s.classList.remove('active');
        }
    });

    window.scrollTo(0, 0);
    // Force init safely
    if (LoginScreen && window.LoginScreen.init) {
        window.LoginScreen.init();
    }
};

window.showProfileModal = function () {
    if (!window.UserManager.currentUser) return;
    // ... (rest of function logic from original if needed, but keeping it mainly for scope fix)
    // Re-implementing simplified version to ensure it works
    const modal = document.getElementById('newProfileModal');
    if (!modal) return;

    modal.querySelector('h3').textContent = 'Cambiar mi Avatar';
    const nameInput = document.getElementById('newProfileName');
    if (nameInput) {
        nameInput.style.display = 'none';
        nameInput.value = window.UserManager.currentUser.name;
    }

    const createBtn = document.getElementById('createProfileBtn');
    if (createBtn) {
        createBtn.disabled = false;
        createBtn.onclick = function () {
            if (window.LoginScreen.selectedAvatar) {
                window.UserManager.currentUser.avatar = window.LoginScreen.selectedAvatar;
                const user = window.UserManager.users.find(u => u.id === window.UserManager.currentUser.id);
                if (user) user.avatar = window.LoginScreen.selectedAvatar;
                window.UserManager.saveUsersList();
                modal.classList.add('hidden');
                if (nameInput) nameInput.style.display = 'block';
            }
        };
    }

    window.LoginScreen.renderAvatarOptions();
    window.LoginScreen.selectAvatar(window.UserManager.currentUser.avatar || window.LoginScreen.avatarSeeds[0]);
    modal.classList.remove('hidden');
};

Logger.info('✅ Login Logic loaded');
